import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from '../../../utility/helper';

const ProtectedRoute = () => {
    const token = getToken();

    if (!token) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;  // Use Outlet instead of children
};

export default ProtectedRoute;